export default __webpack_public_path__ + "static/media/membershipIcon.2664b468.svg";